import type { AxiosError, AxiosRequestConfig } from 'axios'
import router from '@/router'
import { HttpStatusCode } from 'axios'

const COMMON_ERROR_MESSAGE = '查询失败'
const NET_CODE_401_ERROR_MSG = '没有权限, 请重新登录'

function errorAlert(config: AxiosRequestConfig | undefined, msg: string): void {
  if (config?.ignoreError === true) {
    return
  }
  showErrorMessage(msg)
}

function axiosErrorHandler(err: AxiosError, defaultMsg = COMMON_ERROR_MESSAGE): void {
  if (err.response == null) {
    errorAlert(err.config, defaultMsg)
    return
  }
  const status = err.response.status

  if (status === HttpStatusCode.Unauthorized) {
    const { updateProfile } = useProfileStore()
    updateProfile(null)
    errorAlert(err.config, NET_CODE_401_ERROR_MSG)
    void router.replace({ name: 'Login' })
    return
  }

  let message: string
  if (status >= HttpStatusCode.InternalServerError) {
    message = `服务错误(${status})，请稍后重试`
  } else {
    const data = err.response.data
    if (typeof data === 'string') {
      message = data
    } else {
      // 可能是后端返回的结构错误，先显示出来，以便在开发阶段能及早暴露
      message = JSON.stringify(data)
    }
  }
  message ||= `出错了(${status})，请稍后重试`

  errorAlert(err.config, message)
}

export const axios = initAxios(import.meta.env.VITE_BASE_API_PATH)
axios.interceptors.response.use(
  response => response,
  async (error: AxiosError<string>) => {
    axiosErrorHandler(error)
    return Promise.reject(error)
  },
)
